var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M9.85563 16.1698L5.68562 11.9998L4.26562 13.4098L9.85563 18.9998L21.8556 6.99984L20.4456 5.58984L9.85563 16.1698Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
